import React from "react";
import { NavLink, Outlet } from "react-router";
import styled from "@emotion/styled";
import {
  fontFamily,
  fontSize,
  fontWeight,
  spacing,
  interactive,
  nav,
  surface,
  text,
  ThemeProvider,
} from "@atlas-int/tokens";
import { packageRegistry } from "./packageRegistry";

const PageContainer = styled.div`
  display: flex;
  height: 100vh;
  font-family: ${fontFamily.base};
  background-color: ${surface.page};
`;

const Sidebar = styled.nav`
  width: 240px;
  min-width: 240px;
  height: 100vh;
  overflow-y: auto;
  background-color: ${nav.background};
  color: ${text.onDark};
  padding: ${spacing[10]} 0;
  position: fixed;
  left: 0;
  top: 0;
`;

const SidebarTitle = styled.h1`
  font-size: ${fontSize.xl};
  font-weight: ${fontWeight.bold};
  padding: 0 ${spacing[10]};
  margin: 0 0 ${spacing[10]} 0;
`;

const StyledNavLink = styled(NavLink)`
  display: block;
  padding: ${spacing[2]} ${spacing[10]} ${spacing[2]} ${spacing[12]};
  color: ${interactive.muted};
  text-decoration: none;
  font-size: ${fontSize.base};

  &:hover {
    background-color: ${nav.hover};
    color: ${text.onDark};
  }

  &.active {
    color: ${text.onDark};
    background-color: ${nav.hover};
  }
`;

const OverviewLink = styled(NavLink)`
  display: block;
  padding: ${spacing[2]} ${spacing[10]};
  color: ${interactive.muted};
  text-decoration: none;
  font-size: ${fontSize.base};
  margin-bottom: ${spacing[4]};
  border-bottom: 1px solid ${nav.hover};
  padding-bottom: ${spacing[4]};

  &:hover {
    color: ${text.onDark};
  }

  &.active {
    color: ${text.onDark};
    font-weight: ${fontWeight.semibold};
  }
`;

const Content = styled.main`
  flex: 1;
  margin-left: 240px;
  overflow-y: auto;
  padding: ${spacing[16]} ${spacing[20]};
`;

const PackagesLayout: React.FC = () => {
  return (
    <ThemeProvider theme="light">
      <PageContainer>
        <Sidebar>
          <SidebarTitle>Packages</SidebarTitle>
          <OverviewLink to="/packages" end>
            Overview
          </OverviewLink>
          {packageRegistry.map((pkg) => (
            <StyledNavLink key={pkg.id} to={`/packages/${pkg.id}`}>
              {pkg.name}
            </StyledNavLink>
          ))}
          <StyledNavLink
            to="/packages/architecture"
            style={{ marginTop: spacing[4], borderTop: `1px solid ${nav.hover}`, paddingTop: spacing[4] }}
          >
            Site Architecture
          </StyledNavLink>
        </Sidebar>
        <Content>
          <Outlet />
        </Content>
      </PageContainer>
    </ThemeProvider>
  );
};

export default PackagesLayout;
